import * as services from './services'

export const getTemplate = async function(rootStore: any, options: any = {}) {
  const { pageStore = {} } = rootStore
  const { params = {}, query = {} } = pageStore
  const { dataSourceAlias = '', selectedRowsStr = '' } = options
  const needParams = {
    query: {
      ...query,
      billno: params?.billNo ?? '',
      billId: params?.billId ?? null,
      domainCode: params?.domainKey,
      appCode: params?.appCode ?? '',
      datasource: dataSourceAlias ?? '',
      busiObj: options.busiObj || query.busiObj
    }
  }
  const res = await services.getTemplateByBo(needParams)
  if (res?.code !== 200) {
    return Promise.reject(res?.message)
  }
  return res
}